import {Component, OnInit} from '@angular/core';
import {environment} from '../../../../../../environments/environment';
import {HttpService} from '../../../../../shared/_services/http.service';
import {ValidationService} from '../../../../../shared/_services/validation.service';
import {ReportsService} from '../../../../../shared/_services/reports.service';
import {UtilService} from '../../../../../shared/_services/util.service';
import {IMyDateModel, IMyDpOptions} from 'mydatepicker';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {

  report: any = FormGroup;

  myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    editableDateField: false,
    inline: false,
    // disableUntil: {year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() - 1},
    openSelectorOnInputClick: true
  };

  reportOperations = [
    {id: 'GEN', name: 'Generation Report'},
    {id: 'EXC', name: 'Canje Report'},
  ];

  fiscalOrigins = [
    {id: 'EPI ESPANA', name: 'EPI España'},
    {id: 'BEACH', name: 'Beach'},
    {id: 'GRIEGO', name: 'Griego'},
    {id: 'CENTRAL MX', name: 'Central MX'},
    {id: 'ATLANTIC', name: 'Atlantic'},
    {id: 'FBENI', name: 'Fbeni'},
    {id: 'GRECO', name: 'Greco'},
    {id: 'MONACO', name: 'Mónaco'},
    {id: 'PAPAGAYO', name: 'Papagayo'},
    {id: 'CANCUN', name: 'Cancún'},
    {id: 'CARACOL', name: 'Caracol'},
    {id: 'PLAYCAR', name: 'Playcar'},
    {id: 'FINISTERRA', name: 'Finisterra'},
    {id: 'SANBLAS', name: 'Sanblas'},
    {id: 'TODOS', name: 'All'}
  ];

  documentUrl: String = null;
  errorDetails: String = null;
  serverEndpoint = this.reportService.getGeneratedReport;

  constructor(
    private fb: FormBuilder,
    private http: HttpService,
    private validationService: ValidationService,
    private utilService: UtilService,
    private reportService: ReportsService,
  ) {

  }

  initForm() {
    this.report = this.fb.group({
      dateTo: ['', Validators.compose([Validators.required, this.validationService.simpleCheckDateRange.bind(this)])],
      dateFrom: ['', Validators.compose([Validators.required, this.validationService.simpleCheckDateRange.bind(this)])],
      operationType: ['', Validators.required],
      fiscalOrigin: ['', Validators.required],
      fiscalDestination: ['', Validators.required]
    });
  }


  ngOnInit() {
    this.initForm();
    this.report.controls['operationType'].valueChanges.subscribe(value => {
      if (value !== 'EXC') {
        this.report.controls['fiscalDestination'].disable();
      } else {
        this.report.controls['fiscalDestination'].enable();
      }
    });
  }

  onDateChanged(event: IMyDateModel, type) {
    this.report.get(type).setValue(event.formatted);
    this.report.get(type).markAsDirty();
    this.report.get(type).markAsTouched();
    if (type === 'dateFrom' && !this.report.get('dateTo').value) {
      const dateTo = new Date(event.formatted);
      dateTo.setMonth(dateTo.getMonth() + 2);
      this.report.get('dateTo').setValue(
        {
          date: {
            year: dateTo.getFullYear(),
            month: dateTo.getMonth(),
            day: dateTo.getDay(),
          }
        }
      );
      this.report.get('dateTo').setValue(
        {
          formatted: `${dateTo.getMonth()}/${dateTo.getDate()}/${dateTo.getFullYear()}`
        }
      );
    }
  }

  generateReport() {
    const dateFrom = new Date(this.report.value.dateFrom.formatted);
    const dateTo = new Date(this.report.value.dateTo.formatted);
    var start_date = dateFrom.getFullYear() + '-' + (dateFrom.getMonth() + 1).toString().padStart(2,'0') + '-' + dateFrom.getDate().toString().padStart(2,'0');
    var end_date = dateTo.getFullYear() + '-' + (dateTo.getMonth() + 1).toString().padStart(2,'0') + '-' + dateTo.getDate().toString().padStart(2,'0');
    let data = {
      startingDate: start_date,
      endingDate: end_date,
      fiscalOrigin: this.report.value.fiscalOrigin
    };
    this.serverEndpoint = this.reportService.getGeneratedReport;
    if (this.report.value.operationType === 'EXC') {
      data = {...data, ...{fiscalDestination: this.report.value.fiscalDestination}};
      this.serverEndpoint = this.reportService.getExchangeReport;
    }
    this.serverEndpoint(data)
      .subscribe(
        res => {
          if (res.message === '200 OK') {
            this.documentUrl = environment.REPORTS_HOST + res.responseObj;
            this.errorDetails = '';
          } else {
            this.errorDetails = res.message;
            this.documentUrl = '';
          }
        },
        error => {
          this.errorDetails = error.message;
          this.documentUrl = '';
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/reports/reports/reports.component.ts